if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"SkynamoDesignSystem","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(webpack_sharing_consume_default_(chart(_js_chart_js|js\-plugin\-trendline_chartjs\-plugin\-trendline)|vue(\-chartjs_vue\-chartjs|\-demi_vue\-demi|_vue)|moment_moment)|SkynamoDesignSystem\-styles)$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}